<template>
  <div>
    <div class="d-flex justify-content-end">
      <b-button variant="primary" v-b-modal.addModal class="my-1">
        Add Bank
      </b-button>
    </div>

    <!-- Add Bank Account Modal -->
    <b-modal id="addModal" title="Add Bank Account" v-model="showAddModal" class="mb-2 col-12" centered :hide-footer="true">
      <b-row>
        <b-form class="mb-2 col-12" @submit.prevent="AddBank">
          <!-- Bank Name & Type -->
          <b-row>
            <b-col md="4">
              <b-form-group label="Bank Name" label-for="bankNameInput">
                <b-form-input
                  id="bankNameInput"
                  v-model="newBank.bankName"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <b-form-group label="Type" label-for="typeInput">
                <b-form-input
                  id="typeInput"
                  v-model="newBank.name"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        
          <!-- Account Number & Currency -->
          <b-row>
            <b-col md="6">
              <b-form-group label="Account Number" label-for="accNumInput">
                <b-form-input
                  id="accNumInput"
                  v-model="newBank.accountNumber"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Currency" label-for="currencyInput">
                <b-form-input
                  id="currencyInput"
                  v-model="newBank.currency"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        
          <!-- Code & Balance -->
          <b-row>
            <b-col md="6">
              <b-form-group label="Code" label-for="code">
                <b-form-input
                  id="code"
                  v-model="newBank.code"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Current Balance" label-for="currenctBalance">
                <b-form-input
                  id="currenctBalance"
                  v-model="newBank.currentBalance"
                  type="number"
                  step="0.01"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        
          <!-- Description -->
          <b-row>
            <b-col md="12">
              <b-form-group label="Description" label-for="editDescription">
                <b-form-textarea
                  id="editDescription"
                  v-model="newBank.description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        
          <!-- <b-row>
            <b-col md="6" class="d-flex align-items-center">
              <b-form-group class="mb-0" label="Is Existing Account ?" label-for="existAccSwitch">
                <b-form-checkbox v-model="isExistingAccount" switch id="existAccSwitch"></b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Type" label-for="accNumInput">
                <b-form-input id="accNumInput" v-model="newBank.type" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Opening Balance Date" label-for="opBalDate">
                <flat-pickr :disabled="!isExistingAccount" class="form-control" id="opBalDate"
                  v-model="newBank.openingBalanceDate" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Opening Balance" label-for="openingBalanceInput">
                <b-form-input id="openingBalanceInput" v-model="newBank.openingBalance" type="number" step="0.01"
                  :disabled="!isExistingAccount"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
          <div class="modal-footer justify-content-end">
            <b-button
              variant="primary"
              class="ml-2"
              type="submit"
              :disabled="invalid"
            >
              <b-spinner small v-if="loading" class="mx-2" />
              Add
            </b-button>
          </div>
        </b-form>
      </b-row>

    </b-modal>
    <!-- Add Credit Card Modal -->
    <b-modal id="addCCModal" title="Add Credit Card" v-model="showAddCCModal" centered>
      <b-row>
        <b-col md="6">
          <b-form-group label="Bank Name" label-for="bankNameInput">
            <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="optionBanks" label="title" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Account Name" label-for="accountNameInput">
            <b-form-input id="accountNameInput" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="IBAN Code" label-for="ibanInput">
            <b-form-input id="ibanInput" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Last 4 digits of CC Number" label-for="cc4Input">
            <b-input-group class="align-items-center">
              <b-input-group-prepend> XXXX-XXXX-XXXX- </b-input-group-prepend>
              <b-form-input id="cc4Input" required></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Account Type" label-for="accountTypeInput">
            <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="optionAccType" label="title" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Description" label-for="editDescription">
            <b-form-textarea id="editDescription"></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Currency" label-for="currencyInput">
            <b-form-input id="currencyInput" value="MUR" required readonly></b-form-input>
          </b-form-group>
        </b-col>
        <!-- <b-col md="6" class="d-flex align-items-center">
          <b-form-group class="mb-0" label="Is Existing Account ?" label-for="existAccSwitch">
            <b-form-checkbox v-model="isExistingAccount" switch id="existAccSwitch"></b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Opening Balance Date" label-for="opBalDate">
            <flat-pickr :disabled="!isExistingAccount" class="form-control" id="opBalDate" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Opening Balance" label-for="openingBalanceInput">
            <b-form-input id="openingBalanceInput" :disabled="!isExistingAccount"></b-form-input>
          </b-form-group>
        </b-col> -->
      </b-row>
    </b-modal>
    <!-- View Bank Account Modal -->
    <b-modal id="viewModal" title="View Bank Account" v-model="showViewModal" centered>
      <p><strong>Bank Name: </strong>{{ selectedBank.bankName }}</p>
      <p><strong>Type: </strong>{{ selectedBank.name }}</p>
      <p><strong>Account Number: </strong>{{ selectedBank.accountNumber }}</p>
      <p><strong>Currency: </strong>{{ selectedBank.currency }}</p>
      <p><strong>Code: </strong>{{ selectedBank.code }}</p>
      <p><strong>Balance: </strong>{{ selectedBank.currentBalance }}</p>
      <p><strong>Description: </strong>{{ selectedBank.description }}</p>
      <!-- <p><strong>Opening Balance Date: </strong>{{ selectedBank.openingBalanceDate }}</p>
      <p><strong>Opening Balance: </strong>{{ selectedBank.openingBalance }}</p> -->
      <p>
        <strong>IsActive: </strong>{{ selectedBank.isActive }}
      </p>
    </b-modal>
    <!-- Edit Bank Account Modal -->
    <b-modal id="editModal" title="Edit Bank Account" v-model="showEditModal" centered :hide-footer="true">
      <b-row>
        <b-form class="mb-2 col-12" @submit.prevent="editBank">
          <b-row>
            <b-col md="4">
              <b-form-group label="Bank Name" label-for="bankNameInput">
                <b-form-input v-model="selectedBank.bankName" label="title"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <b-form-group label="Type" label-for="name">
                <b-form-input id="name" v-model="selectedBank.name" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Account Number" label-for="accNumInput">
                <b-form-input id="accNumInput" v-model="selectedBank.accountNumber" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Currency" label-for="currencyInput">
                <b-form-input id="currencyInput" value="MUR" v-model="selectedBank.currency" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Code" label-for="code">
                <b-form-input id="code" v-model="selectedBank.code" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Current Balance" label-for="currencbalanceInput">
                <b-form-input id="currenctBalance" v-model="selectedBank.currentBalance" type="number"
                  step="0.01"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group label="Description" label-for="editDescription">
                <b-form-textarea
                  id="editDescription"
                  v-model="selectedBank.description"
                  rows="3"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="6" class="d-flex align-items-center">
              <b-form-group class="mb-0" label="Is Existing Account ?" label-for="existAccSwitch">
                <b-form-checkbox v-model="isExistingAccount" switch id="existAccSwitch"></b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Type" label-for="accNumInput">
                <b-form-input id="accNumInput" v-model="selectedBank.type" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Opening Balance Date" label-for="opBalDate">
                <flat-pickr :disabled="!isExistingAccount" class="form-control" id="opBalDate"
                  v-model="selectedBank.openingBalanceDate" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Opening Balance" label-for="openingBalanceInput">
                <b-form-input id="openingBalanceInput" v-model="selectedBank.openingBalance" type="number" step="0.01"
                  :disabled="!isExistingAccount"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" block :disabled="invalid" @click="editBank()">
              <b-spinner small v-if="loading" class="mx-2" />Update
            </button>
          </div>
        </b-form>
      </b-row>
    </b-modal>

    <!-- Bank List -->
    <b-table :items="filteredBanks" :fields="fields" :current-page="currentPage" :per-page="perPage"
      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive striped>

      <template #head(bankName)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-input v-model="filters.bankName" placeholder="Search Bank Name" size="sm" />
        </div>
      </template>

      <template #head(name)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-input v-model="filters.name" placeholder="Search Name" size="sm" />
        </div>
      </template>

      <template #head(currency)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-input v-model="filters.currency" placeholder="Search currency" size="sm" />
        </div>
      </template>

      <template #head(currentBalance)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-input v-model="filters.currentBalance" placeholder="Search current Balance" size="sm" />
        </div>
      </template>

      <template #head(description)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-input v-model="filters.description" placeholder="Search description" size="sm" />
        </div>
      </template>

      <template #head(isActive)="scope">
        <div class="d-flex flex-column">
          <span>{{ scope.label }}</span>
          <b-form-select
            v-model="filters.isActive"
            :options="[ 
              { value: null, text: 'All' },
              { value: true, text: 'Active' },
              { value: false, text: 'Inactive' }
            ]"
            size="sm"
          ></b-form-select>
        </div>
      </template>
      






      <template #cell(bankName)="row">
        {{ row.value }}
      </template>
      <template #cell(name)="row">
        {{ row.value }}
      </template>

      <template #cell(currentBalance)="row">
        {{ row.value }}
      </template>
      <template #cell(actions)="row">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
          </template>
          <b-dropdown-item :to="{ name: 'income', params: { id: row.item.id } }">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>Income</span>
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'expenses', params: { id: row.item.id } }">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>Expenses</span>
          </b-dropdown-item>
          <b-dropdown-item  :to="{ name: 'reconciliation', params: { id: row.item.id } }">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>Reconciliation</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item @click="openViewModal(row.item)">
            <feather-icon icon="EyeIcon" class="mr-50" />
            <span>View</span>
          </b-dropdown-item> -->
          <b-dropdown-item v-b-modal.editModal @click="openEditModal(row.item)">
            <feather-icon icon="EditIcon" class="mr-50" />
            <span>Edit</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item to="/accounting/accounts-bank/acc-statements">
            <AccStatementIcon width="14" svgColor="#6e6b7b" />
            <span class="ml-50">Account Statement</span>

          </b-dropdown-item> -->
          <!-- <b-dropdown-item to="/accounting/accounts-bank/fund-transfers" >
               
                <FundTransfersIcon width="14" svgColor="#6e6b7b" />
              <span class="ml-50">Fund Transfers</span>
             
              
             
            </b-dropdown-item> -->

          <!-- <b-dropdown-item to="/accounting/accounts-bank/reconcile">
            <ReconcileIcon width="14" svgColor="#6e6b7b" />
            <span class="ml-50">Reconcile</span>
          </b-dropdown-item>

          <b-dropdown-item to="/accounting/accounts-bank/bank-statement">

            <BankStatementIcon width="14" svgColor="#6e6b7b" />
            <span class="ml-50">Bank Statements</span>


          </b-dropdown-item>

          <b-dropdown-item to="/accounting/accounts-bank/check-transactions">
            <CheckTransactionIcon width="14" svgColor="#6e6b7b" />
            <span class="ml-50">Cheque Transactions</span>

          </b-dropdown-item> -->
        </b-dropdown>
      </template>

      <template #cell(status)="row">
        <b-badge :variant="getStatusVariant(row.item.status)" pill>
          {{ row.item.status }}
        </b-badge>
      </template>

      <template #cell(isActive)="row">
        <b-badge :variant="row.item.isActive ? 'success' : 'danger'" pill>
          {{ row.item.isActive ? 'Active' : 'Inactive' }}
        </b-badge>
      </template>
      
    </b-table>

    <div class="d-flex justify-content-center mb-1">
      <b-spinner variant="success" label="Spinning" block v-if="loading" style="width: 3rem; height: 3rem"></b-spinner>
    </div>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
        <b-form-group>
          Showing 
          {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
          to 
          {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
          of 
          {{ totalRows > 0 ? totalRows : 0 }} 
          entries
        </b-form-group>
    </b-col>

  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BTable,
  BPagination,
  BRow,
  BCol,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormTextarea,
  VBTooltip,
  BFormSelect,
  BBadge,
  BModal,
  VBModal,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner, BForm
} from "bootstrap-vue";

import income from "../income/income.vue";
import CreditCardIcon from "./CreditCardIcon.vue";
import AddBankAccIcon from "./AddBankAccIcon.vue";
import ReconcileIcon from "./ReconcileIcon.vue";
import FundTransfersIcon from "./FundTransfersIcon.vue";
import AccStatementIcon from "./AccStatementIcon.vue";
import CheckTransactionIcon from "./CheckTransactionIcon.vue";
import BankStatementIcon from "./SalesReportIcon.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SearchBar from "@/components/search-component/SearchBar.vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
export default {
  components: {
    BFormInput,
    BFormGroup,
    BTable,
    BPagination,
    BRow,
    BCol,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BFormSelect,
    BBadge,
    BModal,
    CreditCardIcon,
    AddBankAccIcon,
    BDropdown,
    BDropdownItem,
    vSelect,
    flatPickr,
    BFormCheckbox, SearchBar,
    ReconcileIcon, BankStatementIcon, CheckTransactionIcon, FundTransfersIcon, AccStatementIcon,
    BSpinner, BForm
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-modal": VBModal,
  },
  data() {
    return {
      bankName: "",
      name: "",
      description: "",
      currency: "",
      currentBalance: "",
      isActive: "",
      isExistingAccount: false,
      showAddModal: false,
      showEditModal: false,
      showAddCCModal: false,
      showViewModal: false,
      selectedBank: {
        bankName: "",
        name: "",
        code: "",
        currency: "",
        accountNumber: "",
        currentBalance: 0,
        description: "",
        type: "",
        openingBalanceDate: null,
        openingBalance: 0,
        isActive: "",
        isExistingAccount: false
      },
      optionBanks: [{ title: "MCB" }, { title: "SBM" }, { title: "Other" }],
      optionAccType: [
        { title: "Checking" },
        { title: "Savings" },
        { title: "Credit Card" },
      ],
      items: [],
      // banks: [
      //   {
      //     bankName: "Bank A",
      //     accountType: "Checking",
      //     reconciliationMethod: "Automated",
      //     contactInfo: "123-456-7890",
      //     balance: 100000,
      //     status: "Reconciled",
      //     isExistingAccount: true
      //   },
      //   {
      //     bankName: "Bank B",
      //     accountType: "Savings",
      //     reconciliationMethod: "Manual",
      //     contactInfo: "987-654-3210",
      //     balance: 100000,
      //     status: "Unreconciled",
      //     isExistingAccount: false
      //   },
      //   {
      //     bankName: "Bank C",
      //     accountType: "Credit Card",
      //     reconciliationMethod: "Automated",
      //     contactInfo: "555-123-4567",
      //     balance: 100000,
      //     status: "Updating",
      //     isExistingAccount: false
      //   },
      //   {
      //     bankName: "Bank D",
      //     accountType: "Checking",
      //     reconciliationMethod: "Manual",
      //     contactInfo: "111-222-3333",
      //     balance: 100000,
      //     status: "Reconciled",
      //     isExistingAccount: false
      //   },
      // ],
      newBank: {
        bankName: "",
        name: "",
        code: "",
        currency: "",
        accountNumber: "",
        currentBalance: 0,
        description: "",
        type: "",
        openingBalanceDate: null,
        openingBalance: 0,
        isActive: ""
      },
      searchTerm: "",
      sortBy: "bankName",
      sortDesc: false,
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "bankName", label: "Bank Name", filterable: true, sortable: true },
        { key: "name", label: "Type", filterable: true, sortable: true },
        { key: "currency", label: "Currency", filterable: true, sortable: true },
        { key: "currentBalance", label: "Current Balance", filterable: true, sortable: true },
        { key: "description", label: "Description", filterable: true, sortable: true },
        { key: "isActive", label: "Status", filterable: true },
        { key: "actions", label: "Actions" },
      ],
      filters: {
        bankName: "",
        name: "",
        currency: "",
        currentBalance: "",
        description: "",
        isActive: null,
      },
    };
  },
  methods: {

    filterTable() {
      this.currentPage = 1;
      this.totalRows = this.filteredBanks.length;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    successAdd() {
      this.$swal({
        title: "Bank Added!",
        text: "You have successfully added a bank!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    // error
    errorAdd() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successEdit() {
      this.$swal({
        title: "Bank edited!",
        text: "You have successfully edited a bank!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    // error
    errorEdit() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    ...mapActions("bankModule", ["getBankListAction", "getBankIDAction", "addBankAction", "updateBankAction"]),
    data(data) {
      if (data) {
        this.getBankListAction();
      }
    },

    AddBank() {
      let payload = {
        bankName: this.newBank.bankName,
        name: this.newBank.name,
        currency: this.newBank.currency,
        description: this.newBank.description,
        currentBalance: this.newBank.currentBalance,
        code: this.newBank.code,
        accountNumber: this.newBank.accountNumber,
        type: 0,
        // openingBalanceDate: this.newBank.openingBalanceDate,
        // openingBalance: this.newBank.openingBalance,
        isActive: true
      };
      this.addBankAction(payload)
        .then(() => {
          this.successAdd();
          this.$bvModal.hide("modal-main");
          this.newBank.bankName = "";
          this.newBank.name = "";
          this.newBank.currency = "";
          this.newBank.description = "";
          this.newBank.currentBalance = "";
          this.newBank.code = "";
          this.newBank.accountNumber = "";
          this.newBank.openingBalanceDate = null;
          this.newBank.openingBalance = "";
          this.getBankListAction();
        })
        .catch(() => {
          this.errorAdd();
          this.$bvModal.hide("modal-main");
          this.newBank.bankName = "";
          this.newBank.name = "";
          this.newBank.currency = "";
          this.newBank.description = "";
          this.newBank.currentBalance = "";
          this.newBank.code = "";
          this.newBank.accountNumber = "";
          this.newBank.openingBalanceDate = null;
          this.newBank.openingBalance = "";
          this.getBankListAction();
        });

    },

    editBank() {

      let payload = {
        id: this.selectedBank.id,
        bankName: this.selectedBank.bankName,
        name: this.selectedBank.name,
        currency: this.selectedBank.currency,
        description: this.selectedBank.description,
        currentBalance: this.selectedBank.currentBalance,
        code: this.selectedBank.code,
        accountNumber: this.selectedBank.accountNumber,
        // openingBalanceDate: this.selectedBank.openingBalanceDate,
        // openingBalance: this.selectedBank.openingBalance,
      };
      this.updateBankAction(payload)
        .then(() => {
          this.successEdit();
          this.$bvModal.hide("editModal");
          this.getBankListAction();

        })
        .catch(() => {
          this.errorEdit();
          this.$bvModal.hide("editModal");
          this.getBankListAction();
        });
    },

    getStatusVariant(status) {
      return {
        Reconciled: "success",
        Unreconciled: "danger",
        Updating: "warning",
      }[status];
    },

    openAddModal() {
      this.showAddModal = true;
    },
    openAddCCModal() {
      this.showAddCCModal = true;
    },
    openViewModal(bank) {
      this.selectedBank = bank;
      this.showViewModal = true;
    },
    openEditModal(bank) {
      this.selectedBank = bank;
      this.showEditModal = true;
    },
  },
  computed: {
    ...mapGetters("bankModule", {
      banks: "bank",
      loading: "loading",
    }),

    filteredBanks() {
    return this.banks.filter((bank) => {
      return (
        (!this.filters.bankName ||
          bank.bankName
            .toLowerCase()
            .includes(this.filters.bankName.toLowerCase())) &&
        (!this.filters.name ||
          bank.name.toLowerCase().includes(this.filters.name.toLowerCase())) &&
        (!this.filters.currency ||
          bank.currency
            .toLowerCase()
            .includes(this.filters.currency.toLowerCase())) &&
        (!this.filters.currentBalance ||
          bank.currentBalance
            .toString()
            .includes(this.filters.currentBalance.toString())) &&
        (!this.filters.description ||
          bank.description
            .toLowerCase()
            .includes(this.filters.description.toLowerCase())) &&
        (this.filters.isActive === null || bank.isActive === this.filters.isActive)
      );
    });
  },
  },

  async mounted() {
    await this.getBankListAction()
      .then((response) => {
        console.log(response);
      })
      .catch((response) => {
        console.log(response);
      });

    this.totalRows = this.banks.length;
  },
};
</script>
<style>
div #viewModal footer {
  display: none !important;
}

.input-group:not(.bootstrap-touchspin):focus-within {
  box-shadow: none;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>